export const getFirstAndLastName = (name: string) => {
	const splittedName = name.split(' ');
	const firstName = splittedName.at(0);
	const lastName = splittedName.at(-1);
	return splittedName.length > 1
		? `${firstName} ${lastName}`
		: (firstName ?? '');
};
